var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-modal", { attrs: { id: "jerseyModal", "hide-footer": true } }, [
    _c(
      "div",
      { attrs: { id: "busForm" } },
      [
        _c(
          "div",
          { staticClass: "formTitle" },
          [
            _c("svg-image", { attrs: { image: "iconJersey" } }),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.$t("register.form.detail.jersey")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form",
          [
            _c("img", {
              attrs: {
                src: "https://assets.heartwork.co.id/bormar/jersey.jpg",
                alt: "Jersey",
              },
            }),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("register.form.detail.jersey"),
                  "label-for": "",
                  description: _vm.$t("register.form.detail.jerseyd"),
                },
              },
              [
                _c(
                  "b-form-select",
                  [
                    _c("b-form-select-option", { attrs: { value: "XS" } }, [
                      _vm._v("XS"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "S" } }, [
                      _vm._v("S"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "M" } }, [
                      _vm._v("M"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "M" } }, [
                      _vm._v("L"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "XL" } }, [
                      _vm._v("XL"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "2XL" } }, [
                      _vm._v("XXL"),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select-option", { attrs: { value: "3XL" } }, [
                      _vm._v("XXXL"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                attrs: {
                  id: "acceptance",
                  name: "acceptance",
                  value: "accepted",
                  "unchecked-value": "not_accepted",
                },
                model: {
                  value: _vm.formChecked,
                  callback: function ($$v) {
                    _vm.formChecked = $$v
                  },
                  expression: "formChecked",
                },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("register.form.acceptance")) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      block: "",
                      type: "submit",
                      variant: "primary",
                      size: "lg",
                    },
                  },
                  [
                    _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                    _vm._v(" " + _vm._s(_vm.$t("register.form.jbtn"))),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/JerseyModal.vue